import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Tooltip } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import type { ReportIntegrityCheck } from '@/services/reportDocuments.service';

/** Screen-only integrity summary; these checks are never printed or emailed. */
const IntegrityBadge: React.FC<{ checks: ReportIntegrityCheck[] }> = ({ checks }) => {
  const { t } = useTranslation('finance');
  if (!checks.length) return null;
  const failed = checks.filter((c) => !c.passed);
  const tip = (
    <div>
      {checks.map((c) => (
        <div key={c.label}>
          {c.passed ? t('integrityStatusOk') : t('integrityStatusCheck')} - {c.label}
          {c.detail ? `: ${c.detail}` : ''}
        </div>
      ))}
      <div style={{ marginTop: 6, opacity: 0.75 }}>{t('integrityInternalOnly')}</div>
    </div>
  );
  return (
    <Tooltip title={tip}>
      {failed.length ? (
        <Tag color="warning" icon={<WarningOutlined />}>
          {failed.length === 1 ? failed[0].label : t('checksNeedAttention', { count: failed.length })}
        </Tag>
      ) : (
        <Tag color="success" icon={<CheckCircleOutlined />}>
          {checks.length === 1 ? checks[0].label : t('allIntegrityChecksPassed')}
        </Tag>
      )}
    </Tooltip>
  );
};

export default IntegrityBadge;
